import { gql } from '@apollo/client';

export const ALL_IMPACT_THEMES = gql`
  query AllImpactThemes {
    getImpactThemes {
      id
      name
    }
  }
`;
